import { apiResponseType } from "@/Api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";
import { Search } from "lucide-react";
import { Dispatch, SetStateAction, useRef, useState } from "react";

export type TypeSearchBarProps = {
    updateFront: (response) => void,
    setState: Dispatch<SetStateAction<string>>,
    funcSearch: (params) => apiResponseType,
    placeholder?: string,
}

export const SearchComponent = ({updateFront, setState, funcSearch, placeholder = "Pesquisar"}: TypeSearchBarProps) => {
    const searchInput = useRef<HTMLInputElement>();
    const [ lastValue, setLastValue ] = useState<string | null>(null);

    const onSearch = async () => {
        const { current } = searchInput as React.MutableRefObject<HTMLInputElement>;
        if(current.value === lastValue)
            return;
        setState("loading");

        const { data } = await funcSearch({ name: current.value});
        updateFront(data?.response);
        setState("production");
        setLastValue(current.value);
    };
    return (
        <div className="flex gap-2">
            <Input placeholder={placeholder} className="w-500" ref={searchInput as any} onKeyUp={(e) => e.key === "Enter" && onSearch()} /> 
            <Button size="icon" className={cn(colors.bg_primary)} onClick={onSearch}>
                <Search className="size-5" />
            </Button>
        </div>
    );
};